module.exports = __webpack_public_path__ + "static/media/commerce.1057161f.png";